export default dom => {
  const textarea = document.createElement("textarea");
  textarea.value = dom.replace(/\r?\n/g, "\n");
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand("copy");
  textarea.parentElement.removeChild(textarea);
  alert("フォームのHTMLコードをコピーしました");
};
